export const CreateAccount = {
  labelName: 'Nome Completo',
  labelProfile: 'Perfil',
  labelTransportation: 'Empresa Transportadora',
  labelDefinePassword: 'Defina uma palavra-passe',
  labelRetypePassword: 'Repita a palavra-passe',
  bottomText: 'Ao clicar no botão Registar as suas informações são sujeitas a uma validação interna, após a qual será enviado um e-mail de confirmação.'
}



// WEBPACK FOOTER //
// ./src/translations/pt/views/CreateAccount.js